import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import type { UnifiedAsset } from '@/hooks/useAssetsUnified';

export function useAssetsDeepLink(
  assets: UnifiedAsset[] | any[],
  setDetailMode: (mode: 'view' | 'create' | 'edit') => void,
  setDetailAsset: (asset: UnifiedAsset | null) => void,
  setShowDetailDrawer: (open: boolean) => void
) {
  const location = useLocation() as any;
  const navigate = useNavigate();

  useEffect(() => {
    const openCreate: boolean | undefined = location?.state?.openCreate;
    const openAccountId: string | undefined = location?.state?.openAccountId;
    const openAssetId: string | undefined = location?.state?.openAssetId;
    if (!openCreate && !openAccountId && !openAssetId) return;

    // Create flow does not depend on assets list
    if (openCreate) {
      setDetailMode('create');
      setDetailAsset(null);
      setShowDetailDrawer(true);
      navigate('.', { replace: true, state: {} });
      return;
    }

    // View by id requires assets to be present
    if (!Array.isArray(assets) || assets.length === 0) return;

    const idToOpen = openAccountId || openAssetId;
    const target = assets.find((a: any) => a.id === idToOpen) as UnifiedAsset | undefined;
    if (target) {
      setDetailMode('view');
      setDetailAsset(target);
      setShowDetailDrawer(true);
      // Clear state to avoid reopening on re-render or back/forward nav
      navigate('.', { replace: true, state: {} });
    }
  }, [location?.state?.openCreate, location?.state?.openAccountId, location?.state?.openAssetId, assets, navigate, setDetailMode, setDetailAsset, setShowDetailDrawer]);
}
